import PropTypes from 'prop-types';
import React, { memo, useCallback } from 'react';

import { TOGGLE_BUTTON_SIZES } from './constants';
import { StyledToggleButton } from './ToggleButton.styles';

const ToggleButton = ({
  size = TOGGLE_BUTTON_SIZES.LARGE,
  fullWidth = true,
  value,
  selected,
  disabled,
  onChange,
  children,
  ...props
}) => {
  const handleChange = useCallback(
    (event) => {
      onChange(event.target.value, event);
    },
    [onChange],
  );

  return (
    <StyledToggleButton
      size={size}
      fullWidth={fullWidth}
      value={value}
      selected={selected}
      disabled={disabled}
      onChange={handleChange}
      {...props}
    >
      {children}
    </StyledToggleButton>
  );
};

ToggleButton.propTypes = {
  size: PropTypes.oneOf(Object.values(TOGGLE_BUTTON_SIZES)),
  fullWidth: PropTypes.bool,
  value: PropTypes.any,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  children: PropTypes.node,
};

export default memo(ToggleButton);
